// extracted by mini-css-extract-plugin
module.exports = {"collapse":"styles_collapse__cw4Bp","collapsedRow":"styles_collapsedRow__cSPnV","a":"styles_a__9yoYJ"};